import { useCallback, useId, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from 'core/i18n/I18nProvider';
import { paths } from 'core/routing/paths';
import { IconClose } from 'shared/assets/icons';
import { LanguageSwitcher } from 'shared/components/LanguageSwitcher';
import { useFocusTrap } from 'shared/hooks/useFocusTrap';
import { useScrollLock } from 'shared/hooks/useScrollLock';
import { PublicNavLinks } from 'navigation/TopNavigation';

export function MobileDrawer({ open, onClose, restoreRef, extra = null }) {
  const { t } = useI18n();
  const panelRef = useRef(null);
  const titleId = useId();
  const handleClose = useCallback(() => {
    onClose();
    window.requestAnimationFrame(() => {
      restoreRef?.current?.focus?.();
    });
  }, [onClose, restoreRef]);

  useFocusTrap(open, panelRef, handleClose);
  useScrollLock(open);

  if (!open) {
    return null;
  }

  return (
    <div className="drawer-layer">
      <button
        type="button"
        className="drawer-backdrop"
        aria-label={t('layout.closeMenu')}
        onClick={handleClose}
      />
      <div
        ref={panelRef}
        className="mobile-drawer is-open"
        id="public-drawer"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <div className="drawer-head">
          <h2 id={titleId}>{t('layout.menu')}</h2>
          <button type="button" className="btn btn-icon" onClick={handleClose} aria-label={t('layout.closeMenu')}>
            <IconClose />
          </button>
        </div>
        <PublicNavLinks className="drawer-nav" onNavigate={handleClose} />
        {extra}
        <div className="drawer-foot">
          <LanguageSwitcher />
          <Link className="btn btn-primary btn-block" to={paths.auth} onClick={handleClose}>
            {t('actions.login')}
          </Link>
        </div>
      </div>
    </div>
  );
}
